import { api } from "./api";

const HEALTH_RESOURCE = "/health";
const READINESS_RESOURCE = "/health/ready";
const LIVENESS_RESOURCE = "/health/live";

export const getHealth = async () => {
  const response = await api.get(HEALTH_RESOURCE);
  return response.data;
};

export const getReadiness = async () => {
  const response = await api.get(READINESS_RESOURCE);
  return response;
};

export const getLiveness = async () => {
  const response = await api.get(LIVENESS_RESOURCE);
  return response;
};
